import React from "react";
import { useTranslation } from "react-i18next";
import { StyledLabel, StyledTextInput } from "@aureskonnect/react-ui";
import { AvGroup } from "availity-reactstrap-validation";
import classnames from "classnames";
import { Input } from "antd";

import HidePasswordSvgIcon from "@components/Common/SvgIcons/HidePasswordSvgIcon";
import ShowPasswordSvgIcon from "@components/Common/SvgIcons/ShowPasswordSvgIcon";

import "./index.css";

type FidelityZerosixType = {
    password: string;
    setPassword: Function;
    user: string;
    setUser: Function;
    inputUser: boolean;
    setInputUser: Function;
    inputPassword: boolean;
    setInputPassword: Function;
    setIsEdited: Function;
    setDashboardLink: Function;
    dashboardLink: string;
    apiKey: string;
    setApiKey: Function;
    inputApiKey: boolean;
    inputDashboardLink: boolean;
    setInputApiKey: Function;
    setInputDashboardLink: Function;
    isConsult?: Boolean;
};
export default function FidelityZerosix({
    password,
    setPassword,
    user,
    setUser,
    inputUser,
    setInputUser,
    inputPassword,
    setInputPassword,
    setIsEdited,
    setDashboardLink,
    dashboardLink,
    apiKey,
    setApiKey,
    inputDashboardLink,
    inputApiKey,
    setInputApiKey,
    setInputDashboardLink,
    isConsult,
}: FidelityZerosixType) {
    const { t } = useTranslation();
   
    return (
        <React.Fragment>
            <AvGroup className={` ${isConsult ? "pe-none__clz" : ""}`}>
                <StyledLabel className="required__clz mt-3" htmlFor="name">
                    {t("User")}
                </StyledLabel>
                <StyledTextInput
                    autoComplete="new-password"
                    id="User"
                    name="User"
                    placeholder={t("Write")}
                    type="text"
                    onChange={(e: any) => {
                        if (/^\s/.test(e.target.value)) {
                            setUser(e.target.value.trim());
                        } else {
                            setUser(e.target.value);
                        }
                        setInputUser(false);
                        setIsEdited(true);
                    }}
                    className={classnames({
                        input__clz: inputUser,
                    })}
                    value={user}
                />
                {inputUser ? (
                    <div
                        style={{
                            width: "100%",
                            marginTop: "0.25rem",
                            fontSize: "80%",
                            color: "#f46a6a",
                        }}
                    >
                        {t("Please enter a link to the dashboard")}
                    </div>
                ) : null}
            </AvGroup>
            <AvGroup className={` ${isConsult ? "pe-none__clz" : ""}`}>
                <StyledLabel className="required__clz mt-3" htmlFor="name">
                    {t("Password")}
                </StyledLabel>
                <Input.Password
                    autoComplete="new-password"
                    placeholder={t("Write")}
                    iconRender={(visible) =>
                        visible ? (
                            <ShowPasswordSvgIcon />
                        ) : (
                            <HidePasswordSvgIcon />
                        )
                    }
                    onChange={(e: any) => {
                        if (/^\s/.test(e.target.value)) {
                            setPassword(e.target.value.trim());
                        } else {
                            setPassword(e.target.value);
                        }

                        setInputPassword(false);
                        setIsEdited(true);
                    }}
                    value={password}
                    className={classnames({
                        input__clz: inputPassword,
                    })}
                    style={{
                        height: "38px",
                        borderRadius: "6px",
                        color: "#2b2828",
                        fontSize: "16px",
                        fontFamily: "Segoe UI",
                    }}
                />
                {inputPassword ? (
                    <div
                        style={{
                            width: "100%",
                            marginTop: "0.25rem",
                            fontSize: "80%",
                            color: "#f46a6a",
                        }}
                    >
                        {t("Please enter an password")}
                    </div>
                ) : null}
            </AvGroup>
            <AvGroup className={` ${isConsult ? "pe-none__clz" : ""}`}>
                <StyledLabel className="required__clz mt-3" htmlFor="name">
                    {t("Dashboard Link")}
                </StyledLabel>
                <StyledTextInput
                    autoComplete="off"
                    id="Dashboard Link"
                    name="Dashboard Link"
                    placeholder={t("Write")}
                    type="text"
                    onChange={(e: any) => {
                        if (/^\s/.test(e.target.value)) {
                            setDashboardLink(e.target.value.trim());
                        } else {
                            setDashboardLink(e.target.value);
                        }

                        setInputDashboardLink(false);
                        setIsEdited(true);
                    }}
                    className={classnames({
                        input__clz: inputDashboardLink,
                    })}
                    value={dashboardLink}
                />
                {inputDashboardLink ? (
                    <div
                        style={{
                            width: "100%",
                            marginTop: "0.25rem",
                            fontSize: "80%",
                            color: "#f46a6a",
                        }}
                    >
                        {t("Please enter a link to the dashboard")}
                    </div>
                ) : null}
            </AvGroup>
            <AvGroup className={` ${isConsult ? "pe-none__clz" : ""}`}>
                <StyledLabel className="required__clz mt-3" htmlFor="name">
                    {t("API key")}
                </StyledLabel>
                <StyledTextInput
                    autocomplete="off"
                    id="API key"
                    name="API key"
                    placeholder={t("Write")}
                    type="text"
                    onChange={(e: any) => {
                        if (/^\s/.test(e.target.value)) {
                            setApiKey(e.target.value.trim());
                        } else {
                            setApiKey(e.target.value);
                        }

                        setInputApiKey(false);
                        setIsEdited(true);
                    }}
                    className={classnames({
                        input__clz: inputApiKey,
                    })}
                    value={apiKey}
                />
                {inputApiKey ? (
                    <div
                        style={{
                            width: "100%",
                            marginTop: "0.25rem",
                            fontSize: "80%",
                            color: "#f46a6a",
                        }}
                    >
                        {t("Please enter an API Key")}
                    </div>
                ) : null}
            </AvGroup>
        </React.Fragment>
    );
}
